<template>
  <div
    v-loading.ullscreen.lock="fullLoading"
    v-if="$route.query.info"
    class="login-loading"
    style="width: 100%; height: 100%; color: #096cb8"
    element-loading-text="登录中..."
    element-loading-background="#ffffff"
  />
  <div v-else class="login-page">
    <div class="logo">
      <img src="@/assets/images/login-logo.png" alt />
    </div>
    <div class="center">
      <div class="poster">
        <div class="poster-logo" />
        <div class="re-one" />
        <div class="re-two" />
        <div class="re-three" />
        <div class="people" />
      </div>
      <div class="login-panel">
        <div class="title">
          <h2>{{ arae }}</h2>
          <h3>{{ platform }}</h3>
        </div>
        <div class="panel">
          <ul class="tab">
            <li v-for="role in roleList" :key="role.roleType" :class="{ active: currentRole === role.roleType}" @click="changeLoginRole(role.roleType)">
              {{ role.roleName }}
            </li>
<!--            <li :class="{ active: currentRole === 1 }" @click="changeLoginRole(1)">{{ zikao }}</li>-->
<!--            <li-->
<!--              v-if="zikao == '省考办'"-->
<!--              :class="{ active: currentRole === 4 }"-->
<!--              @click="changeLoginRole(4)"-->
<!--            >{{ "市考办" }}</li>-->
<!--            <li :class="{ active: currentRole === 2 }" @click="changeLoginRole(2)">{{ chiefUnit }}</li>-->
<!--            <li :class="{ active: currentRole === 3 }" @click="changeLoginRole(3)">{{ pilotUnit }}</li>-->
          </ul>
          <div class="info-container">
            <div :class="{ 'username-active': userNameFocus }" class="username">
              <div :class="{ 'user-active': userNameFocus }" class="icon-box" />
              <div class="ipt-box">
                <input
                  v-model.trim="userName"
                  type="text"
                  placeholder="请输入用户名"
                  autofocus
                  @blur="blurUser"
                  @focus="focusUser"
                />
              </div>
            </div>
            <div :class="{ 'password-active': passwordFocus }" class="password">
              <div :class="{ 'password-active': passwordFocus }" class="icon-box" />
              <div class="ipt-box">
                <input
                  v-model.trim="password"
                  type="password"
                  placeholder="请输入密码"
                  @blur="blurPwd"
                  @focus="focusPwd"
                />
              </div>
            </div>
            <p class="tip">{{ tip }}</p>
          </div>
          <el-button
            ref="ipt"
            :loading="loading"
            :class="{ 'can-login': rightUser && rightPwd }"
            type="primary"
            class="btn"
            @click="handleLogin"
          >登录</el-button>
          <!--<div ref="ipt" @click="handleLogin" class="btn" :class="{'can-login': rightUser && rightPwd}">登录</div>-->
        </div>
      </div>
    </div>
    <div class="desc">北京小逗网络科技有限公司 京ICP备14049531号-1</div>
  </div>
</template>

<script>
import Api from "@/api";
import Storage from "@/utils/storage";
import { setToken, removeToken } from "@/utils/auth";
import { mapMutations } from "vuex";
import { rsaEncryptWithString, Encrypt, Decrypt } from "../../utils/encrypt";
import { getToken } from "@/utils/auth";
export default {
  name: "Login",
  inject: ["reload"],
  data() {
    return {
      fullLoading: false,
      loading: false,
      // currentRole: 1,
      currentRole: Number(localStorage.getItem("loginRole"))
        ? Number(localStorage.getItem("loginRole"))
        : 1,
      userName: "",
      password: "",
      tip: "",
      userNameFocus: true,
      passwordFocus: false,
      env: process.env.EVN_CONFIG.trim(),
      devUrl: process.env.ENV_DEV_URL.trim(),
      arae: process.env.ENV_AREA(),
      platform: process.env.ENV_PLATEFORM(),
      roleList: process.env.ENV_ROLE(),
      // zikao: process.env.ENV_ZIKAO,
      // chiefUnit: process.env.ENV_CHIEFUNIT,
      // pilotUnit: process.env.ENV_PILOTUNIT,
      zikao: "",
      chiefUnit: "",
      pilotUnit: "",
      queryList: [],
    };
  },
  computed: {
    rightUser() {
      // return /^\w+$/.test(this.userName) || /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.userName)
      return this.userName.length > 0;
    },
    rightPwd() {
      return /^[0-9A-Za-z]{6,20}$/.test(this.password);
    },
  },
  async mounted() {
    this.getName();
    //先获取对应的后端域名
    await this.getMappingUrl();
    // 获取从广西幼专登录页面传来的登录信息
    if (this.$route.query.info) {
      const queryList = Decrypt(this.$route.query.info).split("&");
      this.queryList = queryList;
      queryList.forEach((item) => {
        if (item.includes("userName")) {
          this.userName = item.split("=")[1];
        }
        if (item.includes("pwd")) {
          this.password = item.split("=")[1];
        }
        if (item.includes("url") || item.includes("fromUrl")) {
          localStorage.setItem("fromUrl", item.split("=")[1]);
        }
      });
      this.fullLoading = true;
      this.handleLogin();
    } else {
      localStorage.removeItem("fromUrl");
      window.addEventListener("keydown", this.keyLogin);
    }
  },
  methods: {
    ...mapMutations("user", ["saveRealName"]),
    keyLogin(e) {
      if (e.keyCode === 13) {
        if (this.rightUser && this.rightPwd) {
          this.handleLogin();
        }
      }
    },
    // 更改登录角色
    changeLoginRole(val) {
      this.currentRole = val;
    },

    focusUser() {
      this.userNameFocus = true;
      this.passwordFocus = false;
      if (!this.rightUser) {
        this.tip = "";
      }
    },

    focusPwd() {
      this.passwordFocus = true;
      this.userNameFocus = false;
      if (this.rightUser) {
        this.tip = "";
      }
    },

    blurUser() {
      this.userNameFocus = false;
      if (this.userName === "") {
        this.tip = "请输入用户名";
      }
      // else if(!this.rightUser) {
      //   this.tip = '用户名不合法'
      // }
    },

    blurPwd() {
      this.passwordFocus = false;
      if (this.password === "" && this.rightUser) {
        this.tip = "请输入密码";
      } else if (!this.rightPwd && this.rightUser) {
        this.tip = "请输入6位字母或数字密码";
      }
    },

    // 登录
    handleLogin() {
      //登录前从本地拿URL来更改baseURL
      // let protocol = window.location.protocol; //协议
      // axios.defaults.baseURL = `${protocol}//${localStorage.getItem("URL")}`;
      //loginRole是记录用户从哪个角色进入
      localStorage.setItem("loginRole", this.currentRole);
      this.loading = true;
      this.$request
        .login({
          userName: this.userName,
          password: this.password,
          userType: this.currentRole,
        })
        .then((res) => {
          // console.log(res)
          if (res.retcode === "0") {
            this.$message.success("登录成功")
            const roles = [res.userInfo.role];
            setToken(res.token);
            Storage.set("roles", [res.userInfo.role]);
            Storage.set("childRole", res.userInfo.childRole);
            this.$store.dispatch("user/setRoles", {
              roles: roles,
              token: res.token,
            });
            // this.$store.dispatch('user/setRoles', roles, res.token, res.userInfo.realName, res.userInfo.unitPortrait)
            Storage.set("realName", res.userInfo.realName);
            Storage.set("avatar", res.userInfo.unitPortrait);
            Storage.set("UnitId", res.userInfo.unitId);
            setTimeout(() => {
              this.loading = false;
              this.fullLoading = false;
            }, 1000);
            this.$router.push({ path: "/" }).catch(() => {});
          } else {
            //如果是从云测评过来的，则退出返回地址不同
            if (localStorage.getItem("fromUrl")) {
              // 从广西幼专网站登录错误时跳转回原网页
              removeToken();

              const fromUrl = localStorage.getItem("fromUrl");
              if (fromUrl && fromUrl.length > 1) {
                const parser = document.createElement('a')
                if (fromUrl.startsWith("http://") || fromUrl.startsWith("https://")) {
                  parser.href = fromUrl
                } else {
                  parser.href = `${window.location.protocol}//${fromUrl}`
                }
                const errTip = this.phoneTip || this.pwdTip || '登录失败'
                location.replace(`${parser.protocol}//${parser.host}${parser.pathname}?err=${Encrypt(errTip)}`);
              }
            } else {
              this.tip = res.retdesc;
              this.loading = false;
            }
          }
        })
        .catch((err) => {
          this.fullLoading = false;
          this.loading = false;
        });
    },
    //根据接口返回url,调用不同地域下的接口，不再通过配置文件修改
    async getMappingUrl() {
      const url = localStorage.getItem("URL")
      if (this.env !== 'prod' && this.devUrl) {
        localStorage.setItem("URL", this.devUrl);
      } else {
        if (url) {
          axios.post(`${window.location.protocol}${process.env.EVN_SERVER}/get_mapping_url`).then(res => {
            let resObj = JSON.parse(res);
            if (resObj && resObj.retcode === '0' && resObj.url) {
              localStorage.setItem("URL", resObj.url);
            }
          })
        } else {
          const res = await axios.post(`${window.location.protocol}${process.env.EVN_SERVER}/get_mapping_url`);
          let resObj = JSON.parse(res);
          if (!resObj) {
            this.$message.error("请求失败，请刷新页面重试");
          } else if (resObj.retcode !== '0') {
            this.$message.error(resObj.retdesc);
          } else if (!resObj.url) {
            this.$message.error("非法请求路径, 请联系技术处理");
          } else {
            localStorage.setItem("URL", resObj.url);
          }
        }
      }
    },
    getName() {
      if (window.location.host == "gdzk.moycp.com") {
        this.zikao = "省考办";
        this.chiefUnit = "主考学校";
        this.pilotUnit = "教学点";
      } else {
        this.zikao = "考试院";
        this.chiefUnit = "主考学校";
        this.pilotUnit = "衔接学校";
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keyLogin);
  },
};
</script>

<style lang="less" scoped>
.login-page {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 60px;
  background: linear-gradient(
    270deg,
    rgba(42, 209, 193, 1) 0%,
    rgba(0, 211, 162, 1) 100%
  );
  box-sizing: border-box;
  .logo {
    width: 203px;
    height: 41px;
    margin: 0 0 0 60px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1300px;
    height: 500px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: space-between;*/
    .poster {
      position: relative;
      margin-left: 40px;
      float: left;
      width: 646px;
      height: 500px;
      // background: url('../../assets/images/login-bg.png') no-repeat;
      background: url("https://cdn-static-web.moycp.com/moycp/zk/images/login-bg.png")
        no-repeat;
      background-size: contain;
      .poster-logo {
        width: 89px;
        height: 88px;
        position: absolute;
        top: 90px;
        right: 270px;
        // background: url('../../assets/images/poster-logo.png') no-repeat;
        background: url("https://cdn-static-web.moycp.com/moycp/zk/images/poster-logo.png")
          no-repeat;
        background-size: contain;
        animation: myfirst 3s infinite ease-in-out;
      }
      @keyframes myfirst {
        0% {
          transform: translate(0px, 0px);
        }
        50% {
          transform: translate(0px, -15px);
        }
        100% {
          transform: translate(0px, 0px);
        }
      }
      .re-one {
        width: 102px;
        height: 186px;
        // background: url('../../assets/images/re-one.png') no-repeat;
        background: url("https://cdn-static-web.moycp.com/moycp/zk/images/re-one.png")
          no-repeat;
        background-size: contain;
        position: absolute;
        top: 200px;
        left: 140px;
        animation: myfirst 3s infinite ease-in-out;
      }
      .re-two {
        width: 102px;
        height: 186px;
        // background: url('../../assets/images/re-two.png') no-repeat;
        background: url("https://cdn-static-web.moycp.com/moycp/zk/images/re-two.png")
          no-repeat;
        background-size: contain;
        position: absolute;
        top: 220px;
        left: 120px;
        animation: myfirst 3s infinite ease-in-out;
      }
      .re-three {
        width: 82px;
        height: 146px;
        // background: url('../../assets/images/re-three.png') no-repeat;
        background: url("https://cdn-static-web.moycp.com/moycp/zk/images/re-three.png")
          no-repeat;
        background-size: contain;
        position: absolute;
        top: 230px;
        left: 100px;
        animation: myfirst 3s infinite ease-in-out;
      }
      .people {
        width: 142px;
        height: 166px;
        // background: url('../../assets/images/people.png') no-repeat;
        background: url("https://cdn-static-web.moycp.com/moycp/zk/images/people.png")
          no-repeat;
        background-size: contain;
        position: absolute;
        top: 290px;
        left: 40px;
      }
    }
    .login-panel {
      width: 440px;
      float: right;
      margin-right: 40px;
      .title {
        width: 440px;
        color: #fff;
        text-align: center;
        margin-bottom: 20px;
        h2 {
          font-size: 32px;
          font-weight: bold;
          line-height: 40px;
        }
        h3 {
          font-size: 32px;
          //font-weight: bold;
          line-height: 40px;
        }
      }
      .panel {
        width: 440px;
        height: 400px;
        background: #fff;
        border-radius: 4px;
        padding: 40px 50px;
        box-sizing: border-box;
        .tab {
          display: flex;
          justify-content: space-between;
          margin-bottom: 60px;
          li {
            font-size: 16px;
            color: #798192;
            position: relative;
            cursor: pointer;
            &.active {
              font-size: 18px;
              font-weight: bold;
              color: #283550;
              &::after {
                position: absolute;
                left: 0;
                bottom: -10px;
                width: 100%;
                height: 4px;
                border-radius: 2px;
                display: block;
                content: "";
                background: linear-gradient(
                  270deg,
                  rgba(22, 219, 184, 1) 0%,
                  rgba(23, 202, 170, 1) 100%
                );
              }
            }
          }
        }
        .info-container {
          height: 170px;
          input {
            border: none;
            outline: none;
            background: #fff;
            font-size: 14px;
          }
          .username,
          .password {
            margin-bottom: 20px;
            display: flex;
            border: 1px solid #dfdfdf;
            border-radius: 4px;
            .icon-box {
              width: 50px;
              height: 50px;
              border-right: 1px solid #dfdfdf;
              // background: #798192
            }
            .ipt-box {
              flex: 1;
              height: 50px;
              input {
                width: 100%;
                height: 50px;
                box-sizing: border-box;
                padding: 0 10px;
                line-height: 50px;
                border-radius: 4px;
              }
            }
          }
          .username {
            &.username-active {
              border: 1px solid #17caaa;
            }
            .icon-box {
              background: url("../../assets/images/user-default.png") center
                no-repeat;
              background-size: 16px 16px;
              &.user-active {
                background: url("../../assets/images/user-active.png") center
                  no-repeat;
                background-size: 16px 16px;
                border-right: 1px solid #17caaa;
              }
            }
          }
          .password {
            margin-bottom: 10px;
            &.password-active {
              border: 1px solid #17caaa;
            }
            .icon-box {
              background: url("../../assets/images/lock-default.png") center
                no-repeat;
              background-size: 16px 16px;
              &.password-active {
                background: url("../../assets/images/lock-active.png") center
                  no-repeat;
                background-size: 16px 16px;
                border-right: 1px solid #17caaa;
              }
            }
          }
          .tip {
            font-size: 12px;
            color: #ff5a4d;
          }
        }
        .btn {
          width: 100%;
          height: 50px;
          /*line-height: 50px;*/
          text-align: center;
          font-size: 20px;
          color: #fff;
          cursor: pointer;
          background: linear-gradient(
            90deg,
            rgba(29, 189, 184, 1) 0%,
            rgba(23, 202, 170, 1) 100%
          );
          border-radius: 4px;
          pointer-events: none;
          display: block;
          border: none;
          outline: none;
          &.can-login {
            pointer-events: auto;
          }
        }
      }
    }
  }
  .desc {
    text-align: center;
    color: #fff;
    position: absolute;
    bottom: 30px;
    width: 100%;
  }

  @media screen and (max-width: 1440px) {
    .logo {
      width: 203px;
      height: 41px;
      margin: 0 0 0 30px;
    }
    .center {
      height: 440px;
      width: 1160px;
      .poster {
        width: 546px;
        height: 440px;
        .poster-logo {
          width: 79px;
          height: 78px;
          position: absolute;
          top: 70px;
          right: 210px;
          // background: url('../../assets/images/poster-logo.png') no-repeat;
          background: url("https://cdn-static-web.moycp.com/moycp/zk/images/poster-logo.png")
            no-repeat;
          background-size: contain;
          animation: myfirst 3s infinite ease-in-out;
        }
        .re-one {
          width: 82px;
          height: 146px;
          top: 186px;
          left: 130px;
        }
        .re-two {
          width: 82px;
          height: 146px;
          top: 194px;
          left: 110px;
        }
        .re-three {
          width: 65px;
          height: 95px;
          top: 206px;
          left: 100px;
        }
        .people {
          width: 122px;
          height: 136px;
          // background: url('../../assets/images/people.png') no-repeat;
          background: url("https://cdn-static-web.moycp.com/moycp/zk/images/people.png")
            no-repeat;
          background-size: contain;
          position: absolute;
          top: 238px;
          left: 29px;
        }
      }
      .login-panel {
        height: 440px;
        .title {
          width: 400px;
        }
        p {
          font-size: 16px;
        }
        h3 {
          font-size: 28px;
        }
        .panel {
          width: 400px;
          height: 350px;
          padding: 30px 40px;
          .tab {
            margin-bottom: 40px;
          }
        }
      }
    }
  }
}
@media (max-width: 1440px) {
  .login-page {
    padding-top: 20px;
    .center {
    }
  }
}
.login-loading /deep/ .el-loading-spinner .path {
  stroke: #096cb8;
}
/deep/ .el-loading-text {
  color: #096cb8;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue